import React from 'react';

import { Box, Display, Flex, Heading, Paragraph } from '@rover/kibble/core';
import { Props as DisplayProps } from '@rover/kibble/core/Display';
import { Props as FlexProps } from '@rover/kibble/core/Flex';
import { Props as ParagraphProps } from '@rover/kibble/core/Paragraph';
import UnorderedList, {
  Icons,
} from '@rover/react-lib/src/components/lists/UnorderedList/UnorderedList';

type ChildrenProps = {
  children?: React.ReactNode;
};

const MAX_LIST_WIDTH = '558px';
const MAX_HEADER_WIDTH = '810px';

const ServiceValueProposition = (props: FlexProps): JSX.Element => (
  <Flex
    data-testid="service-value-proposition-container"
    {...props}
    flexDirection="column"
    alignItems="center"
    maxWidth="100%"
  />
);

ServiceValueProposition.Display = (props: DisplayProps): JSX.Element => (
  <Display
    as="h3"
    marginBottom="6x"
    size="400"
    responsive={false}
    textAlign="center"
    sx={{ 'max-width': MAX_HEADER_WIDTH }}
    {...props}
  />
);

ServiceValueProposition.List = (props: ChildrenProps): JSX.Element => (
  <UnorderedList icon={Icons.CheckMark} width={MAX_LIST_WIDTH} maxWidth="100%">
    {props.children}
  </UnorderedList>
);

ServiceValueProposition.ListItem = (props: ChildrenProps): JSX.Element => (
  <Box marginBottom="8x">{props.children}</Box>
);

ServiceValueProposition.Subtitle = (props: ChildrenProps): JSX.Element => (
  <Heading mb="1x">{props.children}</Heading>
);

ServiceValueProposition.Text = (props: ParagraphProps): JSX.Element => (
  <Paragraph textColor="tertiary" {...props}>
    {props.children}
  </Paragraph>
);

export default ServiceValueProposition;
